exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pagination {\n  text-align: center;\n  list-style: none;\n}\n.pagination li {\n  display: inline-block;\n  width: auto;\n  margin-right: 10px;\n}\n.pagination li.active {\n  color: #ffc107;\n  font-weight: 600;\n}\n.pagination li.page-item a {\n  color: #000;\n}", ""]);

// exports
